import { Avatar, List } from "antd";
import React from "react";
import UserChat from "../../src/assets/user-chat.png";
import UserIcon from "../../src/assets/user-icon.png";
import useIsMobile from "../utils/useIsMobile";

export default function Terms() {
    const isMobile = useIsMobile();
    const data = [
        {
            icon: UserIcon,
            title: "Sebelum Memulai Konsultasi",
            desc: [
                {
                    text: "Mohon pastikan koneksi internet Anda stabil untuk memastikan kelancaran selama video call.",
                },
                {
                    text: "Pastikan mikrofon dan kamera Anda berfungsi dengan baik.",
                },
                {
                    text: "Gunakan perangkat dengan kamera yang berkualitas baik. Pastikan wajah Anda terlihat jelas dengan pencahayaan yang memadai.",
                },
                {
                    text: "Pastikan Anda telah memberikan izin pada browser yang digunakan untuk mengakses kamera dan mikrofon.",
                },
            ],
        },
        {
            icon: UserChat,
            title: "Selama Konsultasi",
            desc: [
                {
                    text: "Berbicara dengan sopan dan menggunakan Bahasa Indonesia.",
                },
                {
                    text: "Pastikan Anda mengenakan pakaian yang sesuai, tidak bertelanjang dada, dan tidak memakai atribut partai politik atau organisasi tertentu.",
                },
                {
                    text: "Hindari penggunaan penutup wajah seperti masker atau filter video yang dapat menghalangi tampilan wajah Anda.",
                },
                {
                    text: "Hindari tindakan asusila atau perilaku yang tidak pantas.",
                },
            ],
        },
    ];

    return (
        <div
            style={{
                backgroundColor: "#fff",
                borderRadius: "10px",
                borderBottom: "5px solid #D90915",
                maxHeight: "100%",
                boxShadow: "0px 0px 5px rgba(0, 0, 0, 0.2)",
                margin: isMobile ? "5px 10px 1em 10px" : 0,
            }}
        >
            <div
                style={{
                    padding: ".9em 0",
                }}
            >
                <hr
                    style={{
                        border: "1px solid #E38F95",
                        marginTop: "1.8rem",
                    }}
                />
                <div style={{ display: "flex" }}>
                    <div className="app-label">
                        <h4
                            style={{
                                textTransform: "uppercase",
                                margin: 0,
                            }}
                        >
                            syarat dan ketentuan
                        </h4>
                    </div>
                </div>
                {/* List */}
                <List
                    itemLayout="horizontal"
                    dataSource={data}
                    style={{
                        padding: "1em",
                    }}
                    renderItem={(item, _index) => (
                        <List.Item
                            style={{
                                padding: "1em 0",
                            }}
                        >
                            <List.Item.Meta
                                avatar={
                                    <Avatar
                                        style={{
                                            lineHeight: "",
                                            display: "flex",
                                            backgroundColor: "#BD1622",
                                        }}
                                        src={
                                            <div
                                                style={{
                                                    width: "28px",
                                                    height: "28px",
                                                    margin: "auto",
                                                }}
                                            >
                                                <img
                                                    src={item.icon}
                                                    alt="icon"
                                                    style={{
                                                        maxWidth: "100%",
                                                        maxHeight: "100%",
                                                        margin: "auto",
                                                    }}
                                                />
                                            </div>
                                        }
                                        size={40}
                                    />
                                }
                                title={
                                    <h6
                                        style={{
                                            margin: 0,
                                            fontSize: "12px",
                                            fontWeight: "600",
                                        }}
                                    >
                                        {item.title}
                                    </h6>
                                }
                                description={
                                    <ul className="list-custom">
                                        {item?.desc?.length > 0
                                            ? item?.desc.map((x, i) => (
                                                <li key={i}>{x.text}</li>
                                              ))
                                            : null}
                                    </ul>
                                }
                            />
                        </List.Item>
                    )}
                />
            </div>
        </div>
    );
}